import React, { useEffect } from 'react';
import './styles.css';

interface Props {
    message: string;
    open: boolean;
    onClose: () => void;
    durationMs?: number;
    className?: string;
}

const Toast: React.FC<Props> = ({ message, open, onClose, durationMs = 2500, className = '' }) => {
    useEffect(() => {
        if (!open) return;
        const timer = setTimeout(onClose, durationMs);
        return () => clearTimeout(timer);
    }, [durationMs, onClose, open]);

    if (!open) return null;

    return (
        <div className={`toast ${className}`.trim()} role="status" aria-live="polite">
            {message}
        </div>
    );
};

export default Toast;
